import { connect } from "react-redux";
import get from "lodash/get";

import getDates from "./../services/date.service";
import { changeTimeReport as onChangeTimeReport } from "../../actions/reportTimeActions";

const mapStateToProps = (state) => ({
  dataState: state.reportRangeTime.dataState,
  reportStartDate: get(state, ["reportRangeTime", "reportRangeTime", "reportStartDate"], getDates.getNullTimeDate(new Date())),
  reportEndDate: get(state, ["reportRangeTime", "reportRangeTime", "reportEndDate"], getDates.getNullTimeDate(new Date())),
  reportStartTime: get(state, ["reportRangeTime", "reportRangeTime", "reportStartTime"], getDates.getNullTimeDate(new Date())),
  reportEndTime: get(state, ["reportRangeTime", "reportRangeTime", "reportEndTime"], getDates.getEndDayTimeDate(new Date())),
});

const mapDispatchToProps = {
  onChangeTimeReport,
};

const withReportTime = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withReportTime };
